// import APIs
import { mutateDutyLinesInBulk } from 'RestAPIs/employees/hours-table';

// import components
import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';

// import external libraries
import { useMutation, useQueryClient } from 'react-query';

// import types
import { MutateDutyLinesInBulkParams } from './useMutateDutyLinesInBulk.types';

const useMutateDutyLinesInBulk = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (params: MutateDutyLinesInBulkParams) => mutateDutyLinesInBulk(params),

    {
      onSuccess: (_data, { employeeId }) => {
        queryClient.invalidateQueries(['hoursTable', employeeId]);
        showSuccessSnackbar();
      },
      onError: showErrorSnackbar
    }
  );
};

export default useMutateDutyLinesInBulk;
